import { render, staticRenderFns } from "./HorizontalYearCalendar.vue?vue&type=template&id=24ae0c39"
import script from "./HorizontalYearCalendar.vue?vue&type=script&lang=js"
export * from "./HorizontalYearCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports